import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "./index.css";
import { getURLparmas } from "../../utils";
import { fetchStoreInfo, login } from "../../api/api";
import { fileUrl, swiperDefault } from "../../const";
import swiperJPG from "./../../asset/img/swiper.jpg";
import componyPNG from "./../../asset/img/compony.png";
import equipmentPNG from "./../../asset/img/equipment.png";
import equipmentDemoPNG from "./../../asset/img/demo-equipment.jpeg";
import warningPNG from "./../../asset/img/warning.png";
import { LoadingOutlined } from "@ant-design/icons";

SwiperCore.use([Autoplay, Pagination]);

const HEADLIST: any = {
  compony: { icon: componyPNG, name: "单位信息", nameEn: "COMPANY" },
  equipment: { icon: equipmentPNG, name: "设备信息", nameEn: "EQUIPMENT" },
};

export const Store = () => {
  const [details, setDetails] = useState<any>(null);

  useEffect(() => {
    const companyId = getURLparmas("companyId"); // ba10b9f7-b2dd-4a69-8ba7-e0359f6caded
    if (!companyId) return;
    login({ username: "system", password: "qwert@12345!" }).then((res: any) => {
      if (res && res.code === 200) {
        localStorage.setItem("token", res.data);
        fetchStoreInfo(companyId).then((resInfo: any) => {
          if (resInfo && resInfo.code === 200) {
            setDetails(resInfo.data);
            document.title = resInfo.data.F_FullName;
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    // if(details){
    const height = document.getElementById("store-content-inner")?.offsetHeight;
    const contentRef = document.getElementById("store-wrapper");
    const storeContentRef = document.getElementById("store-content");
    if (storeContentRef && contentRef && height && height > 0) {
      contentRef.style.height = height + 460 + "px";
      storeContentRef.style.height = height - 20 + "px";
    }
    // }
  }, [details]);

  if (!details)
    return (
      <div className="loading-store">
        <LoadingOutlined />
      </div>
    );

  const renderContentHead = (type: string) => {
    return (
      <div className="content-head">
        <div className="head-icon-container">
          <img src={HEADLIST[type].icon} className="head-icon" alt="" />
        </div>
        <span className="content-title">{HEADLIST[type].name}</span>
        <span className="content-title-en">{HEADLIST[type].nameEn}</span>
      </div>
    );
  };

  return (
    <div className="wrapper" id="store-wrapper">
      <div className="header">
        <div className="title">{details.F_FullName || "-"}</div>
        <div className="swiperWrap">
          <Swiper
            spaceBetween={0}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: true,
            }}
            slidesPerView={1}
            loop={true}
          >
            {(details?.F_ImgPath
              ? details.F_ImgPath.split(",")
              : swiperDefault
            ).map((item: any, index: React.Key | null | undefined) => (
              <SwiperSlide key={index}>
                <img
                  className="swiper-store"
                  src={`${fileUrl}/${item}`}
                  alt=""
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="content" id="store-content">
        <div className="content-inner" id="store-content-inner">
          <div className="content-compony">
            {renderContentHead("compony")}
            <div className="compony-item">
              <div className="compony-item-name">工商注册信息</div>
              <div className="compony-item-name-en">Business register info</div>
              <div className="compony-item-value">
                {details?.F_EnterpriseInformation || "-"}
              </div>
            </div>
            <div className="compony-item">
              <div className="compony-item-name">店铺地址</div>
              <div className="compony-item-name-en">Shop address</div>
              <div className="compony-item-value">
                {details.F_Address || "-"}
              </div>
            </div>
            <div className="compony-item">
              <div className="compony-item-name">认证编号</div>
              <div className="compony-item-name-en">Certification number</div>
              <div className="compony-item-value">
                {details.F_EnCode || "-"}
              </div>
            </div>
            <div className="compony-item">
              <div className="compony-item-name">负责人</div>
              <div className="compony-item-name-en">Person in charge</div>
              <div className="compony-item-value">
                {details.F_Manager || "-"}
              </div>
            </div>
            {/* <div className="compony-item">
              <div className="compony-item-name">联系方式</div>
              <div className="compony-item-name-en">Contact Information</div>
              <div className="compony-item-value">
                {details.F_InnerPhone || "-"}
              </div>
            </div> */}
          </div>
          <div className="content-equipment">
            {renderContentHead("equipment")}
            {details?.EquipmentList.map((item: any) => (
              <div className="equipment-item">
                {/* <div className="mantle-top">
                  {item.F_FullName}
                </div> */}
                <div className="equipment-img-container">
                  <img
                    className="equipment-img"
                    src={`${fileUrl}/${item.F_ImgPath}`}
                    alt="设备"
                  />
                </div>
                <div className="mantle">
                  <div className="equipment-buy">
                    <div>{item.F_FullName}</div>
                    <div>
                      {" "}
                      {`采购日期 ${item.F_CertificationDate.substring(0, 10)}`}
                    </div>
                  </div>
                  <div className="equipment-item-code">
                    <div>{`型号: ${item.F_EquipmentType || "-"}`} </div>
                    <div>{`SN: ${item.F_EnCode}`}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <div>
            <img src={warningPNG} className="footer-warn" alt="" />
          </div>
          <div>
            <div className="footer-zh">
              <span>如果您有任何有关设备的问题，欢迎联系我们。</span>
              <span className="footer-tel">联系电话: 4000067956</span>
            </div>
            <div className="footer-en">
              <span>
                If you have any questions about the equipment, please contact
                us.
              </span>
              <div className="footer-tel-en">Tel: 4000067956</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
